import { useTranslation } from "react-i18next";
import { Link } from "@trussworks/react-uswds";
import styled from "styled-components";
import { AnalyticsAction, logEvent } from "../utils/analytics";
import Collapsible from "./Collapsible";

const SlideUp = styled.div`
  bottom: 0;
  display: block;
  transition: 0.8s;
  visibility: visible;

  &.hidden {
    bottom: -1000px;
    visibility: hidden;
  }
  @media print
    {    
      display: none !important;
    }
`;

const SurveyPrompt = ({
  shouldShowSurvey,
}: {
  shouldShowSurvey: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <SlideUp
      as="div"
      aria-hidden={shouldShowSurvey ? false : true}
      className={`tablet:margin-right-2 padding-y-2 position-fixed right-0 bg-white tablet:radius-top-lg border-top border-dark tablet:border-x z-top width-full tablet:width-mobile padding-x-2 tablet:padding-x-0 ${
        shouldShowSurvey ? "" : "hidden"
      }`}
    >
      <Collapsible
        open
        title={<h2 className="font-body-md m-0">{t("ownpathsurveyQuestion")}</h2>}
      >
        <div className="margin-1 tablet:margin-x-3 ">
          {t("surveyHeading")}
          <br />
          {t("surveyPrompt")}
        </div>
        <div className="display-flex flex-column flex-align-center">
          <Link
            onClick={() => logEvent(AnalyticsAction.VisitSurveyFromPrompt)}
            style={{ color: "white", textDecoration: "none" }}
            className="usa-button margin-x-3 margin-top-2 font-family-heading"
            target="_blank"
            href={t("complaintFormUrl")}
            tabIndex={shouldShowSurvey ? undefined : -1}
          >
            {t("ownpathSurvey")}
          </Link>
        </div>
      </Collapsible>
    </SlideUp>
  );
};
export default SurveyPrompt;
